import React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import { publicPath } from '../../core/helpers';
import { useModal } from '../../context/modal-context';




const MessageBox = ({
    status = 'success',
    translations = {}
}) => {
    const { setModal, setModalOptions } = useModal();
    const closeModal = () => {
        setModalOptions({size: 'default'});
        setModal();
    }
    const t = key => get(translations, key, '-');
    return (
      <div className={cx('mlb-message-box', `mlb-message-box--${status}`)}>
          <div>
              <span className='mlb-message-box_icon'>
                  <img src={publicPath(`static/images/icon-${status}.png`)} alt='' />
              </span>
          </div>
          <h2 className='mlb-message-box_headline'>{t(`form_${status}_message_headline`)}</h2>
          {t(`form_${status}_message_subheadline`) &&
            <p className='mlb-message-box_subheadline'>{t(`form_${status}_message_subheadline`)}</p>}
          {t(`form_${status}_message_desc`) &&
              <div className='mlb-message-box_desc' dangerouslySetInnerHTML={{
                  __html: t(`form_${status}_message_desc`),
              }} />}
          <button className='mlb-btn-primary' onClick={closeModal}>
              {t(`form_${status}_message_btn_primary_text`)}
          </button>
      </div>
    );
};

export default MessageBox;